import { KeyValue } from '../models/model/concretes/shared/key-value.model';

export interface Partner extends KeyValue {
  // only for UI
  displayName: string;
  partnerType: string; // comparator, student...
}

export const COMPARATOR = 'COMPARATOR';
export const STUDENT = 'STUDENT'; // For new student parcours in the future

const comparatorPartners: Partner[] = [
  {
    key: 'MX',
    value: 'MeilleursTaux',
    displayName: 'Meilleurs Taux',
    partnerType: COMPARATOR,
  },
  {
    key: 'LF',
    value: 'LesFurets',
    displayName: 'Les Furets',
    partnerType: COMPARATOR,
  },
];

export const partners: Partner[] = [
  // Comparateurs
  ...comparatorPartners,
];
